// extracted by mini-css-extract-plugin
export default {"LogoBox":"NotFoundPage_LogoBox__7HKGo","_404Img":"NotFoundPage__404Img__syR1d"};